import { useRouteQuery } from '@/use/useRouteQuery'
import _ from 'lodash'

const basicIndexMixin = {
  data () {
    return {
      search: '',
      model: {},
      loading: true
    }
  },
  setup () {
    const page = useRouteQuery('page')
    const type = useRouteQuery('type')

    return {
      page,
      type
    }
  },
  watch: {
    search: 'doSearch'
  },
  methods: {
    doSearch () {
      this.page = 1
      this.loading = true
      this.$nextTick(() => {
        this.onSearch()
      })
    },
    onSearch: _.debounce(function () {
      this.fetchData()
    }, 200),
    setData (data) {
      this.model = data
      this.loading = false
    },
    setPage (page) {
      this.loading = true
      this.page = page
      this.$nextTick(() => {
        this.fetchData()
      })
    }
  }
}

export default basicIndexMixin
